var _g, _rect, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGetPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7:14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 68,
    height: 68,
    rx: 34,
    fill: "black",
    fillOpacity: 0.08
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 68,
    height: 68,
    rx: 34,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7:14",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 27,
    width: 68,
    height: 68
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 61C27 42.2223 42.2223 27 61 27V27C79.7777 27 95 42.2223 95 61V61C95 79.7777 79.7777 95 61 95V95C42.2223 95 27 79.7777 27 61V61Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7:14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4511 52.9374C58.4511 57.803 54.5067 61.7475 49.641 61.7475C44.7753 61.7475 40.8309 57.803 40.8309 52.9374C40.8309 48.0717 44.7753 44.1273 49.641 44.1273C54.5067 44.1273 58.4511 48.0717 58.4511 52.9374Z",
    fill: "#00DAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 83.2832C32.9999 73.7681 40.4505 66.0546 49.6412 66.0546C58.832 66.0546 66.2825 73.7681 66.2825 83.2832V101.099H32.9999V83.2832Z",
    fill: "#00DAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5535 52.9374C81.5535 57.803 77.6091 61.7475 72.7434 61.7475C67.8777 61.7475 63.9333 57.803 63.9333 52.9374C63.9333 48.0717 67.8777 44.1273 72.7434 44.1273C77.6091 44.1273 81.5535 48.0717 81.5535 52.9374Z",
    fill: "#5186FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1022 83.2832C56.1022 73.7681 63.5528 66.0546 72.7435 66.0546C81.9343 66.0546 89.3848 73.7681 89.3848 83.2832V101.099H56.1022V83.2832Z",
    fill: "#5186FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1022 83.2833C56.1022 78.7803 57.8643 74.0816 61.1925 70.8825C63.9334 73.4942 66.2828 77.9972 66.2828 83.2833L66.2838 99.2566H56.1022V83.2833Z",
    fill: "#3278C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7:14",
    x: 0.391304,
    y: 0.391304,
    width: 121.217,
    height: 121.217,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.3043,
    result: "effect1_foregroundBlur_7:14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGetPeople);
export default __webpack_public_path__ + "static/media/logo-get-people.a2ffc563.svg";
export { ForwardRef as ReactComponent };